import { Flex, FlexProps, IconButton } from '@chakra-ui/react';
import { Menu } from 'lucide-react';
import { HEADER_TITLE_HEIGHT } from './layout-constants';

interface NavigationProps extends FlexProps {
    onOpen: () => void;
    isOpen: boolean;
}

export function Navigation({ onOpen, isOpen }: NavigationProps) {
    return (
        <Flex position="absolute" top="0" h={`${HEADER_TITLE_HEIGHT}px`} alignItems="center" zIndex={9999}>
            <IconButton
                display={{ base: isOpen ? 'none' : 'flex', md: 'none' }}
                onClick={onOpen}
                variant="ghost"
                bg="transparent"
                color="var(--chakra-body-text)"
                aria-label="open menu">
                <Menu />
            </IconButton>
        </Flex>
    );
}
